import Vue from 'vue'
import Vuex from 'vuex'

/* Admin:Core */
import smtpConfig from '@/store/Admin/Core/smtpconfig'
import users from '@/store/Admin/Core/users'
import userTypes from '@/store/Admin/Core/user_types'
import abilities from '@/store/Admin/Core/abilities'
import cropperUploads from '@/store/Admin/Core/cropper_uploads'
import fileUpload from '@/store/Admin/Core/file_upload'
import configCompany from '@/store/Admin/Core/config_company'
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* Admin:Defines */
import accountTypes from './Admin/Defines/account_types'
import banks from './Admin/Defines/banks'
import cities from './Admin/Defines/cities'
import currencies from './Admin/Defines/currencies'
import districts from './Admin/Defines/districts'
import promissoryStatuses from './Admin/Defines/promissory_statuses'
/* Admin:App */
import accountActivities from './Admin/App/account_activities'
import bankAccounts from './Admin/App/bank_accounts'
import dashboard from './Admin/App/dashboard'
import donationGroups from './Admin/App/donation_groups'
import donationTypes from './Admin/App/donation_types'
import estates from './Admin/App/estates'
import promissories from './Admin/App/promissories'
import promissoryLines from './Admin/App/promissory_lines'
import safes from './Admin/App/safes'
import tenants from './Admin/App/tenants'
import estateTenants from './Admin/App/estate_tenants'
import estateDocuments from './Admin/App/estate_documents'
/* Admin:Reports */
import incomesReports from './Admin/Reports/incomesReports'
import expensesReports from './Admin/Reports/expensesReports'
import banksReports from './Admin/Reports/banksReports'
import safesReports from './Admin/Reports/safesReports'
import generalReports from './Admin/Reports/generalReports'
import directorReports from './Admin/Reports/directorReports'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    smtpConfig,
    users,
    userTypes,
    abilities,
    cropperUploads,
    fileUpload,
    configCompany,
    accountTypes,
    cities,
    currencies,
    banks,
    districts,
    promissoryStatuses,
    accountActivities,
    bankAccounts,
    dashboard,
    donationGroups,
    donationTypes,
    estates,
    estateDocuments,
    promissories,
    promissoryLines,
    safes,
    tenants,
    estateTenants,
    incomesReports,
    expensesReports,
    banksReports,
    safesReports,
    generalReports,
    directorReports,
  },
  strict: process.env.DEV,
})
